// extracted by mini-css-extract-plugin
module.exports = {"Rectangle":"src-widgets-EventCardConnectedInfo-styles__Rectangle--2Iftt","ConnectedInfoLink":"src-widgets-EventCardConnectedInfo-styles__ConnectedInfoLink--CPjzs"};